import { Collapse } from '@opten/collapse/initializer';
import { getSelectorElementFromElement } from '@opten/dom/get-selector-element-from-element';
import { scrollToElement } from '@opten/scroll/scroll-to-element';

export class ScrollOnLoadComponent {
	private navbar: HTMLElement;

	constructor() {
		this.navbar = document.getElementsByClassName(
			'js-navbar-height'
		)[0] as HTMLElement;
		if (window.location.hash) {
			const target = document.getElementById(
				window.location.hash.slice(1)
			);
			if (target) {
				let offset = this.navbar ? this.navbar.clientHeight * -1 : 0;
				if (target.getAttribute('aria-expanded') === 'false') {
					Collapse.getInstance(
						getSelectorElementFromElement(target)
					).show();
				}
				scrollToElement(target, undefined, undefined, offset);
			}
		}
	}
}
